import angular from 'angular';

import tszReport from './tsz-report';

const tszReportModule = angular.module('tsz.components.tszReport', [])
  .component('tszReport', tszReport);

export default tszReportModule;



// WEBPACK FOOTER //
// ./src/components/tsz-report/tsz-report.module.js